import { PackageItem } from '../Logistic/PackageItem/PackageItem';
import { PRODUCT_TYPES } from '../Logistic/PackageItem/ProductTypes';
import { ServiceOrder } from './ServiceOrder';

export enum SERVICE_ORDER_ITEM_RESOLUTION {
  RESOLUTION_TO_BILL = 0,
  RESOLUTION_PERITAGE = 1,
  RESOLUTION_BONUS_APPLIED = 2,
  RESOLUTION_AUTOMATIC = 3,
}

export const serviceOrderItemResolutionString = {
  [SERVICE_ORDER_ITEM_RESOLUTION.RESOLUTION_TO_BILL]: 'A Facturar',
  [SERVICE_ORDER_ITEM_RESOLUTION.RESOLUTION_PERITAGE]: 'Sujeto a peritaje',
  [SERVICE_ORDER_ITEM_RESOLUTION.RESOLUTION_BONUS_APPLIED]: 'Bonificado',
  [SERVICE_ORDER_ITEM_RESOLUTION.RESOLUTION_AUTOMATIC]: 'Resolución Automática',
};

export interface ServiceOrderItem {
  id: number;
  service_order: ServiceOrder | number;
  product_type?: PRODUCT_TYPES;
  product?: number;
  device?: number;
  unidad?: number;
  package_item?: PackageItem | number;
  used_amount: number;
  name: string;
  serial_number?: string;
  toUpdate?: boolean;
  toDelete?: boolean;
  in_warranty?: boolean;
  stock_technician_amount?: number;
  discarded_amount?: number;
  to_return_amount?: number;
  resolution_status?: SERVICE_ORDER_ITEM_RESOLUTION;
  stock_technician_reviewed?: boolean;
}
